import { PointerEvent, KeyboardEvent } from 'react'

import {
  PointerSensor as LibPointerSensor,
  KeyboardSensor as LibKeyboardSensor,
} from '@dnd-kit/core'

const handler = ({ nativeEvent: event }: PointerEvent | KeyboardEvent) => {
  let current = event.target as HTMLElement

  while (current) {
    // ignore event if element has "data-no-dnd" attribute
    if (current.dataset && current.dataset.noDnd) {
      return false
    }
    current = current.parentElement as HTMLElement
  }

  return true
}

export class PointerSensor extends LibPointerSensor {
  static activators = [
    { eventName: 'onPointerDown', handler },
  ] as (typeof LibPointerSensor)['activators']
}

export class KeyboardSensor extends LibKeyboardSensor {
  static activators = [
    { eventName: 'onKeyDown', handler },
  ] as (typeof LibKeyboardSensor)['activators']
}
